import gql from 'graphql-tag';

export default gql`
mutation ($input: UpdateReportInput!) {
    updateReport (input: $input) {
        __typename
        id
        name
        status
        pages{            
          index
          name
          displayName
          default
          visible
        }
        reportTypeId
        menuLabel
        menuOrder
        powerBiDataset
        powerBiEmbedUrl
        powerBiReport
        accessToken      
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Reports/UpdateMutation.js